import React from 'react';
import { DungeonBotPage } from '../DungeonBotPage.js';

export const GameSessionsPage: React.FC = () => {
  return <DungeonBotPage initialSection="sessions" />;
};
